import { Ref } from 'react';

import Badge from '@atlaskit/badge';
import Button from '@atlaskit/button';
import { CustomTriggerProps } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import Spinner from '@atlaskit/spinner';
import Tooltip from '@atlaskit/tooltip';

import { useIntl } from 'src/hooks/intl';

import messages from './filter-dropdown-trigger.i18n';
import * as styles from './filter-dropdown-trigger.styled';

type FilterDropdownTriggerProps = {
  selectedCount: number;
  isLoading: boolean;
  label: string;
  tooltipText?: string;
  isMenuOpen: boolean;
  appearance: 'default' | 'subtle';
  triggerRef?: Ref<any>;
  buttonProps?: Omit<CustomTriggerProps, 'triggerRef'>;
};

export const FilterDropdownTrigger = (props: FilterDropdownTriggerProps) => {
  const intl = useIntl();
  const {
    selectedCount,
    label,
    isLoading,
    isMenuOpen,
    appearance,
    tooltipText,
    triggerRef,
    buttonProps,
  } = props;

  return (
    <Button
      {...buttonProps}
      ref={triggerRef}
      shouldFitContainer
      isDisabled={isLoading}
      appearance={appearance || 'subtle'}
      iconAfter={
        isLoading ? (
          <Spinner size="small" />
        ) : (
          <ChevronDownIcon
            label={intl.formatMessage(messages.expandIconLabel)}
          />
        )
      }
      isSelected={isMenuOpen}
    >
      <Tooltip content={tooltipText || label} position="top" delay={600}>
        <styles.DropdownLabelContainer>
          <styles.DropdownLabelTextContainer>
            {label}
          </styles.DropdownLabelTextContainer>
          {selectedCount > 0 && (
            <styles.DropdownLabelBadgeContainer>
              <Badge appearance="primary">{selectedCount}</Badge>
            </styles.DropdownLabelBadgeContainer>
          )}
        </styles.DropdownLabelContainer>
      </Tooltip>
    </Button>
  );
};
